import { type AxiosInstance } from "axios";
import { z } from "zod";

const nullableString = z.string().nullable();
const nullableNumber = z.number().nullable();

export const FarmlandDetailSchema = z.object({
  daichoId: nullableString,
  realEstateType: z.string(),
  location: z.string(),
  chiban: z.string(),
  landCategory: z.string(),
  area: z.number(),
  rightsSetupStatus: z.string(),
  expiredAt: nullableString,
  ooaza: nullableString,
  normalizationLocation: z.string(),
  prefectureName: z.string(),
  prefectureCode: z.string(),
  cityName: z.string(),
  cityCode: z.string(),
  latitude: nullableNumber,
  longitude: nullableNumber,
  farmCommitteeCd: nullableString,
  farmCommitteeName: nullableString,
  todofukenCode: nullableString,
  shikuchosonCode: nullableString,
  oazaCode: nullableString,
  address: nullableString,
  tiban: nullableString,
  daichoShubetsuCd: nullableString,
  classificationOfLandCode: nullableString,
  classificationOfLandName: nullableString,
  areaOnRegistry: nullableNumber,
  sectionOfNoushinhouCode: nullableString,
  sectionOfNoushinhouName: nullableString,
  sectionOfToshikeikakuhouCode: nullableString,
  sectionOfToshikeikakuhouName: nullableString,
  ownerFarmIntentionCode: nullableString,
  ownerFarmIntentionName: nullableString,
  kindOfRightCode: nullableString,
  kindOfRightName: nullableString,
  commencementDate: nullableString,
  endStagesDate: nullableString,
  rightSettingContentsCode: nullableString,
  rightSettingContentsName: nullableString,
  rightOfMiddleManagement: nullableString,
  usageSituationInvestigationDate: nullableString,
  usageSituationInvestigationResultCode: nullableString,
  usageSituationInvestigationResultName: nullableString,
  useIntentionInvestigationDate: nullableString,
  ownerStatementIntentSurveyResultsCode: nullableString,
  ownerStatementIntentSurveyResultsName: nullableString,
  useIntentionAscertainmentResultCode: nullableString,
  useIntentionAscertainmentResultName: nullableString,
  publicNoticeDate: nullableString,
  recommendationContentDate: nullableString,
  actionOrderDate: nullableString,
  mayorPublicAnnouncementDate: nullableString,
  sectionOfPolygonCode: nullableString,
  sectionOfPolygonName: nullableString,
});

export type FarmlandDetail = z.infer<typeof FarmlandDetailSchema>;

export const getFarmlandDetailAPI = async (
  apiClient: AxiosInstance,
  daichoId: string,
  signal?: AbortSignal
): Promise<FarmlandDetail> => {
  const response = await apiClient.get<unknown>(
    `map/farmlands/${encodeURIComponent(daichoId)}`,
    { signal }
  );

  return FarmlandDetailSchema.parse(response.data);
};
